import { ICustomCta } from '@campaign-form/campaign-form.interface';
import { EExecutionType } from '../deliverable-flow-dialog/execution-step/execution-list/execution/execution.interface';

export type TCtaSummaryDeliverable = ICustomCta & { id?: string | null; name?: string | null; type?: string | null };
export type TCtaSummaryKpi = ICustomCta & { expectedValue?: number | null; id?: string | null; kpi?: string | null };
export type TCtaSummaryExecution = ICustomCta & {
  duration?: number | null;
  executionCountTarget?: number | null;
  executionDate?: Date | null;
  executionTime?: Date | null;
  executionStartDate?: Date | null;
  executionEndDate?: Date | null;
  executionType?: EExecutionType | null;
  expectedKpis?: TCtaSummaryKpi[];
  id?: string | null;
};
export type TCtaSummaryExecutionRow = TCtaSummaryExecution & { durationLabel: string | null; label: string };

export const EXECUTION_TYPE_ORDER: Record<EExecutionType, number> = {
  [EExecutionType.unique]: 0,
  [EExecutionType.timeFrame]: 1,
  [EExecutionType.undesignated]: 2,
  [EExecutionType.always]: 3,
  [EExecutionType.noExpectations]: 4,
};

// The creator-overridable summary fields, by how their override (always an API string) is parsed.
export const CTA_SUMMARY_DATE_FIELDS = ['executionDate', 'executionEndDate', 'executionStartDate', 'executionTime'];
export const CTA_SUMMARY_NUMBER_FIELDS = ['duration', 'executionCountTarget', 'expectedValue'];
